import api from '../../api'

export default {
  props: {
    token: {
      default: ''
    }
  },
  name: 'ConfirmEmail',
  data: () => {
    return {
      isEmailConfirmed: false
    }
  },
  created () {
    const router = this.$router
    api.get.confirmEmail(this.token)
      .then(() => {
        this.isEmailConfirmed = true
        setTimeout(() => router.push('/login'), 5000)
      })
      .catch(() => this.$notify({
        message: 'Произошла ошибка',
        type: 'danger'
      }))
  }
}
